import React, { useEffect } from "react";

interface SearchModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
}

export function SearchModal({
  isOpen,
  onClose,
  children,
  className = "",
}: SearchModalProps) {
  // モーダルが開いている間は背景のスクロールを無効化
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center pt-[10vh] px-4">
      {/* オーバーレイ */}
      <div
        className="fixed inset-0 bg-black/50 transition-opacity"
        onClick={onClose}
      />

      {/* モーダルコンテンツ */}
      <div
        className={`relative bg-white rounded-lg text-left shadow-xl w-full sm:max-w-lg ${className}`}
      >
        {children}
      </div>
    </div>
  );
}
